<script setup lang="ts">
import { defineEmits } from "vue";
import CloseButton from "@/components/buttons/CloseButton.vue";

defineEmits(["close"]);
</script>

<template>
  <div
    class="h-12 xl:h-16 flex justify-between items-center pr-4 md:pr-6 xl:pr-2 border-b border-ternary top-14 w-full z-10 bg-secondary xl:static"
  >
    <slot name="header-content" />
    <CloseButton @clicked="$emit('close')" class="ml-auto" />
  </div>
</template>
